import { render, staticRenderFns } from "./ProducingPage.vue?vue&type=template&id=4ec6c677&"
import script from "./ProducingPage.ts?vue&type=script&lang=js&"
export * from "./ProducingPage.ts?vue&type=script&lang=js&"
import style0 from "./ProducingPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports